import { useEffect, useMemo, useRef } from "react";
import { useQuery } from "convex/react";
import { useLocation, useNavigate } from "react-router-dom";
import { api as convexApi } from "../../convex/_generated/api";
import {
  classifySessionHandoffRoute,
  resolveSessionHandoffAction,
} from "./sessionHandoffRoute.ts";
import {
  readSeenHandoffRevision,
  writeParticipantHandoffIntent,
  writeSeenHandoffRevision,
} from "./sessionHandoffStorage.ts";
import { sessionMovedCopy } from "./notificationCopy.ts";
import { notify } from "./notify.ts";

export function SessionHandoffCoordinator() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const route = useMemo(() => classifySessionHandoffRoute(pathname), [pathname]);
  const target = useQuery(
    convexApi.sessions.getLiveSessionHandoff,
    route.surface === "excluded" ? "skip" : {},
  );
  const memoryRevisionRef = useRef<number | null>(null);

  useEffect(() => {
    if (route.surface === "excluded" || target === undefined) return;
    const storedRevision = readSeenHandoffRevision();
    const seenRevision = storedRevision ?? memoryRevisionRef.current;
    const action = resolveSessionHandoffAction({ route, target, seenRevision });
    if (action.type === "none") return;

    memoryRevisionRef.current = action.revision;
    writeSeenHandoffRevision(action.revision);
    if (action.type === "navigate") {
      if (route.surface === "participant" && target) {
        writeParticipantHandoffIntent({
          revision: action.revision,
          targetSessionId: target.targetSessionId,
        });
      }
      if ((route.surface === "admin" || route.surface === "moderator") && target) {
        notify.success(sessionMovedCopy(target.sessionTitle));
      }
      navigate(action.path, { replace: true });
    }
  }, [navigate, route, target]);

  return null;
}
